import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {CityService} from '@services/city.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-menages',
    templateUrl: './menages.component.html',
    styleUrls: ['./menages.component.scss']
})
export class MenagesComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();
    user: User = Object.assign({}, EMPTY_USER);
    tabs = 'country';
    secteur = '';
    iris = '';

    compare = [];
    displayedColumns: string[] = ['lib', 'quartier', 'secteur', 'ville', 'france'];

    options = {
        tooltip: {
            trigger: 'item',
            formatter: '{c} {b} ({d} %)'
        },
        legend: {
            show: true,
            top: 'bottom',
            left: 'center',
            data: ['Personnes seules', 'Familles avec 1 enfant', 'Familles avec 2 enfants', 'Familles avec 3 enfants', 'Familles avec 4 enfants', 'Familles avec 4 enfants ou plus']
        },
        calculable: true,
    };

    data = {
        series: []
    };

    constructor(
        public cityService: CityService,
        public deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService) {
    }


    ngOnInit() {
        if (this.favorite.iris != ''
            && this.favorite.ad_city.mapping_quartier_iris != null
            && this.favorite.ad_city.mapping_quartier_iris.quartier != null) {
            this.tabs = 'quartier';
        }
        this.iris = this.favorite.iris;
        if (this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length == 1) {
            // this.secteur = this.favorite.ad_city.mapping_quartier_iris.quartier[0].GQ_c;
            // this.iris = this.secteur;
            this.displayedColumns = ['lib', 'quartier', 'ville', 'france'];
        }
        if (!this.favorite.ad_city.mapping_quartier_iris || !this.favorite.ad_city.mapping_quartier_iris.quartier) {
            this.displayedColumns = ['lib', 'ville', 'france'];
        }

        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
        this.user = this.authenticationService.currentUser;
    }

    setData() {
        if (this.iris != '') {
            this.secteur = this.iris.substring(0, 7);
        }

        let irisData = null;
        if (this.iris != '' && this.favorite.ad_city.menage_iris[this.iris]) {
            irisData = this.favorite.ad_city.menage_iris[this.iris];
        }

        let secteurData = null;
        if (this.secteur != '' && this.favorite.ad_city.menage_gq[this.secteur]) {
            secteurData = this.favorite.ad_city.menage_gq[this.secteur];
        }

        let root = this.favorite.ad_city.menage;
        if (this.tabs == 'quartier') {
            if (this.secteur == '') {
                // Tout la ville = nothing
            } else if (this.iris.length == 7 && secteurData) {
                root = secteurData;
            } else if (this.iris.length > 7 && irisData) {
                root = irisData;
            }
        }

        this.data = {
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: ['0%', '30%'],
                    bottom: '15%',
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: 'center',
                        color: 'black',
                        fontSize: 20
                    },
                    color: ['#FFFFFF'],
                    data: [
                        {
                            value: Math.round(root.C_MEN),
                            name: (Math.round(root.C_MEN)).toString() + '\nMénages'
                        },

                    ],
                },
                {
                    name: '',
                    type: 'pie',
                    color: ['#67C2EF', '#79C447', '#FABB3D', '#1277AA', '#9C9C9C', '#FF5455'],
                    radius: ['55%', '81%'],
                    bottom: '15%',
                    label: {
                        show: false,
                        position: 'outer',
                        alignTo: 'labelLine',
                        bleedMargin: 5,
                    },
                    // radius: [30, 110],
                    // roseType: 'area',
                    data: [
                        {value: Math.round(root.T_seul * root.C_MEN), name: 'Personnes seules'},
                        {value: Math.round(root.T_F_0enf * root.C_MEN), name: 'Familles sans enfants'},
                        {value: Math.round(root.T_F_1enf * root.C_MEN), name: 'Familles avec 1 enfant'},
                        {value: Math.round(root.T_F_2enf * root.C_MEN), name: 'Familles avec 2 enfants'},
                        {value: Math.round(root.T_F_3enf * root.C_MEN), name: 'Familles avec 3 enfants'},
                        {value: Math.round(root.T_F_4enf * root.C_MEN), name: 'Familles avec 4 enfants ou plus'},
                    ]
                }
            ]
        };


        if (this.deviceService.isMobile()) {
            this.data.series[0].label.fontSize = 18;
        }

        this.compare = [
            {
                'lib': 'Ménages',
                'quartier': (irisData != null ? new Intl.NumberFormat('fr-FR').format(irisData.C_MEN) : '-'),
                'secteur': (secteurData != null ? new Intl.NumberFormat('fr-FR').format(secteurData.C_MEN) : '-'),
                'ville': new Intl.NumberFormat('fr-FR').format(this.favorite.ad_city.menage.C_MEN),
                'france': new Intl.NumberFormat('fr-FR').format(this.favorite.ad_city.menage_fr.C_MEN),
            },
            {
                'lib': 'Personnes seules',
                'quartier': (irisData != null ? (irisData.T_seul * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_seul * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.menage.T_seul * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.menage_fr.T_seul * 100).toFixed(1) + ' %',
            },
            {
                'lib': 'Familles sans enfants',
                'quartier': (irisData != null ? (irisData.T_F_0enf * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_F_0enf * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.menage.T_F_0enf * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.menage_fr.T_F_0enf * 100).toFixed(1) + ' %',
            },
            {
                'lib': 'Familles avec 1 enfant',
                'quartier': (irisData != null ? (irisData.T_F_1enf * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_F_1enf * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.menage.T_F_1enf * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.menage_fr.T_F_1enf * 100).toFixed(1) + ' %',
            },
            {
                'lib': 'Familles avec 2 enfants',
                'quartier': (irisData != null ? (irisData.T_F_2enf * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_F_2enf * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.menage.T_F_2enf * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.menage_fr.T_F_2enf * 100).toFixed(1) + ' %',
            },
            {
                'lib': 'Familles avec 3 enfants',
                'quartier': (irisData != null ? (irisData.T_F_3enf * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_F_3enf * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.menage.T_F_3enf * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.menage_fr.T_F_3enf * 100).toFixed(1) + ' %',
            },
            {
                'lib': 'Familles avec 4 enfants ou plus',
                'quartier': (irisData != null ? (irisData.T_F_4enf * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_F_4enf * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.menage.T_F_4enf * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.menage_fr.T_F_4enf * 100).toFixed(1) + ' %',
            },
        ];
    }

    edit(event, fields = '') {
        if (fields == 'secteur') {
            this.iris = this.secteur;
        }
        this.setData();
    }

    toogleTabs(t) {
        this.tabs = t;
        this.setData();
    }
}
